import Vue from 'vue';
import {
  Icon, Image, Button,
  Sidebar, SidebarItem,
  Tab, Tabs,
  Swipe,
  SwipeItem,
  NoticeBar,
  Sticky,
} from 'vant';
import LazyContainer from "@/components/LazyLoad/LazyContainer";
import LazyItem from "@/components/LazyLoad/LazyItem";
import BackTop from "@/components/FloatBtn/BackTop";
import './style.less';

const list = [
  Icon,
  Button,
  Image,
  SidebarItem,
  Sidebar,
  Tab,
  Tabs,
  Swipe,
  SwipeItem,
  Image,
  NoticeBar,
  Sticky,
];
list.forEach(c => Vue.use(c));

[LazyItem, LazyContainer, BackTop].forEach(c => Vue.component(c.name, c));

export {default as title_text} from './TitleText';
export {default as goods} from './Goods';
export {default as goods_tag_list} from './GoodsTagList';
export {default as image_ad} from './ImageAd';
export {default as image_text_nav} from './ImageTextNav';
export {default as rich_text} from './RichText';
export {default as cube} from './Cube';
export {default as blank} from './Blank';
export {default as search} from './Search';
export {default as store_info} from './StoreInfo';
export {default as notice} from './Notice';
export {default as groupon} from './Groupon';
export {default as coupon} from './Coupon';
export {default as seckill} from './Seckill';
export {default as point_trade} from './PointTrade';
export {default as gift_packet} from './GiftPacket';
export {default as Tabbar} from './Tabbar';
